import React from 'react';
import Pagination from 'react-bootstrap/Pagination';
import PropTypes from "prop-types";

interface TypePagination {
    totalPages: number;
    currentPage: number;
    onPageChange: (page: number) => void;
    children?: React.ReactNode; // children 속성 정의
}

const CustomPagination = ({totalPages, currentPage, onPageChange}: TypePagination) => {

    const visiblePageCount = 3; // 한 번에 표시할 최대 페이지 수 (여기를 3으로 변경)
    const ellipsisThreshold = 1; // 이 값 이상일 때 "..." 표시

    const handlePageChange = (page: number) => {
        if (page >= 1 && page <= totalPages) {
            onPageChange(page);
        }
    };

    const renderPageNumbers = () => {
        const result = [];
        if (totalPages <= visiblePageCount) {
            // 페이지 수가 visiblePageCount 이하인 경우 모든 페이지를 표시
            for (let i = 1; i <= totalPages; i++) {
                result.push(
                    <Pagination.Item
                        key={i}
                        active={i === currentPage}
                        onClick={() => handlePageChange(i)}
                    >
                        {i}
                    </Pagination.Item>
                );
            }
        } else {
            const leftEllipsis = currentPage > ellipsisThreshold + 2;
            const rightEllipsis = currentPage < totalPages - ellipsisThreshold - 1;

            if (leftEllipsis) {
                result.push(
                    <Pagination.Item
                        key={1}
                        onClick={() => handlePageChange(1)}
                    >
                        {1}
                    </Pagination.Item>
                );
                result.push(<Pagination.Ellipsis key="left-ellipsis"/>);
            }

            const start = leftEllipsis ? currentPage - ellipsisThreshold : 1;
            const end = rightEllipsis ? currentPage + ellipsisThreshold : totalPages;

            for (let i = start; i <= end; i++) {
                result.push(
                    <Pagination.Item
                        key={i}
                        active={i === currentPage}
                        onClick={() => handlePageChange(i)}
                    >
                        {i}
                    </Pagination.Item>
                );
            }

            if (rightEllipsis) {
                result.push(<Pagination.Ellipsis key="right-ellipsis"/>);
                result.push(
                    <Pagination.Item
                        key={totalPages}
                        onClick={() => handlePageChange(totalPages)}
                    >
                        {totalPages}
                    </Pagination.Item>
                );
            }
        }

        return result;
    };

    return (
        <Pagination style={{WebkitUserSelect: 'none'}}>
            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)}
                             disabled={currentPage === 1}>뒤로</Pagination.Prev>
            {renderPageNumbers()}
            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)}
                             disabled={currentPage === totalPages}>앞으로</Pagination.Next>
        </Pagination>
    );
};

export default CustomPagination;
